// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { InteractiveProduct,RecommendationsState } from '@coveo/headless/commerce';
import { CoveoCommerceState } from "@DSG/Store/Data/CoveoCommerceState";
import { BadgeModel, ProductInventoryDto, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";

export interface CoveoProductModel {
    title: string;
    brandName: string;
    categoryName:string;
    subBrandName: string;
    shortDescription: string;
    productNumber: string;
    manufacturerItem: string;
    availability: [];
    urlSegment: string;
    imageAltText: string;
    mediumImagePath: string;
    smallImagePath: string;
    pricing: ProductPriceDto | null;
    inventory: ProductInventoryDto | undefined;
    badges?: BadgeModel[];
    // variantTypeId: string | null;
    canAddToCart: boolean;
    quoteRequired: boolean;
    minimumOrderQty: string;
    allowZeroPricing: boolean;
    unitListPrice: number;
    // vendorAuthRequiredList: string;
    // vendorAuthRequiredLink: string;
    unitofmeasure: string;
    productId: string;
    canonicalUrl: string;
    saleType: string | null;
    onSaleNow: string | null;
    brandUrlSegment: string;
    showAuthorizationRequired: boolean;
    responseId: string;
    customerProductNumber: string;
    previousPurchaseDate:string;
    interactiveProduct? : InteractiveProduct | null;
    upcCode: string;
    isdiscontinued:boolean;
}
export interface CoveoProductInfo {
    productId: string;
    qtyOrdered: number;
    unitOfMeasure: string;
    failedToLoadPricing?: true;
    failedToLoadInventory?: true;
    productDetailPath: string;
    pricing?: ProductPriceDto;
    inventory?: ProductInventoryDto;
} 

export interface ListUpdatedProductQtyInfo {
    ListUpdatedProductQtyInfo: string;
    qtyOrdered: number;
} 

export interface UpdatedProductQtyInfo {
    productId: string;
    qtyOrdered: number;
} 

export interface RecommendationInfo {
    recommendationState: RecommendationsState;
    slotId: string;
} 

// export const mapCoveoProductInfo = (result: CoveoProductModel): CoveoProductInfo => ({
//     productId: result.productId,
//     qtyOrdered: Math.max(Number(result.minimumOrderQty), 1),
//     unitOfMeasure: result.unitofmeasure,
//     productDetailPath: `${result.urlSegment}`,
// });

export const mapCoveoProductInfo = (result: CoveoProductModel,productQtyInfo: UpdatedProductQtyInfo[]) => {
    let qty= Math.max(Number(result.minimumOrderQty), 1)
    
    const matchingQtyInfo = productQtyInfo?.find(
        (info) => info.productId === result.productId
    );

    if (matchingQtyInfo) {
        qty = matchingQtyInfo.qtyOrdered;
    }

    // if(productQtyInfo?.productId !=="" && productQtyInfo?.productId === result.productId){
    //     qty= productQtyInfo.qtyOrdered
    // }
    return ({
        productId: result.productId,
        qtyOrdered: qty,
        unitOfMeasure: result.unitofmeasure,
        productDetailPath: `${result.urlSegment}`,
    }) as CoveoProductInfo;
}